"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safePath = exports.safeProp = void 0;

var _utils = require("./utils");

var _data = _interopRequireDefault(require("data.either"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var safeProp = (0, _utils.curry)(function (prop, obj) {
  if (prop === null) {
    return _data.default.Left("You are missing the property argument for this function.");
  }

  if (obj === null) {
    return _data.default.Left("You are missing the object argument for this function.");
  }

  if ((0, _utils.isString)(prop) === false) {
    return _data.default.Left("All object property accessors must be of type string: ".concat(prop, " is a ").concat((0, _utils.capitalize)(_typeof(prop)), "."));
  }

  if ((0, _utils.isObject)(obj) === false) {
    return _data.default.Left("");
  }

  if ((0, _utils.hasProp)(obj, prop) === false) {
    return _data.default.Left("The property \"".concat(prop, "\" does not exist on the passed in object."));
  }

  return _data.default.fromNullable(obj[prop]).leftMap(function () {
    return "The value for the property \"".concat(prop, "\" is either null or undefined on the passed in object.");
  });
});
exports.safeProp = safeProp;
var safePath = (0, _utils.curry)(function (props, obj) {
  if (props === null) {
    return _data.default.Left("You are missing the property path argument for this function.");
  }

  if (obj === null) {
    return _data.default.Left("You are missing the object argument for this function.");
  }

  if (Array.isArray(props) === false) {
    return _data.default.Left("The property path argument must be an array. You passed in: ".concat((0, _utils.capitalize)(_typeof(props)), "."));
  }

  if ((0, _utils.isObject)(obj) === false) {
    return _data.default.Left("");
  }

  return props.reduce(function (acc, prop) {
    return acc.chain(safeProp(prop));
  }, _data.default.Right(obj));
});
exports.safePath = safePath;